import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from '@emotion/styled';
import { layout } from '../styles';
import { shadow1 } from '../styles/util';
import { fromThemeColors } from '../Theme';
export var StyledFlyover = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tpadding: ", ";\n\tborder: 1px solid ", ";\n\tborder-radius: 4px;\n\tbackground: ", ";\n\tbox-shadow: ", ";\n"])), layout.mediumSpace, fromThemeColors('border'), fromThemeColors('flyoverBackground'), shadow1.boxShadow);